import { render, staticRenderFns } from "./SponsorshipLevelInfo.vue?vue&type=template&id=253e6dc0&"
import script from "./SponsorshipLevelInfo.vue?vue&type=script&lang=js&"
export * from "./SponsorshipLevelInfo.vue?vue&type=script&lang=js&"
import style0 from "./SponsorshipLevelInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports